var config = require('../config.js')
module.exports = {
    storedCard: config.host + '/market/api/v1/storedCard/myListByStoredCard/c', //获取我的礼品卡
    // storedCardmyLisUsable: config.host + '/market/api/v1/storedCard/myLisUsableStoredCard/c', //获取我的礼品卡
    storedCardmyStoredCardShow: config.host + '/market/api/v1/storedCard/myStoredCardShow/c', //获取我的礼品卡
    // storedCardmyStoredCardShow: config.host + '/market/api/v1/storedCard/myLisUsableStoredCard/c', //获取我的礼品卡
    storedCardManageList: config.host + '/market/api/v1/storedCard/list/c', //获取礼品卡列表
    storedCardDetail: config.host + '/market/api/v1/storedCard/detail/c', //获取礼品卡详情
    storedCardMsg: config.host + '/market/api/v1/storedCard/myDetail/c', //获取礼品卡详情
    myDefiniteDetail: config.host + '/market/api/v1/storedCard/myDefiniteDetail/c', //获取礼品卡明细
    storedCardExchange: config.host + '/market/api/v1/storedCard/storedCardExchange/c', //兑换绑卡
    storedCardValid: config.host + '/market/api/v1/storedCard/storedCardValid/c', //无效卡片
    getBalance: config.host + '/market/api/v1/userBalanceRecharge/getBalance/c', //获取余额
    getBalanceConfig: config.host + '/market/api/v1/userBalanceRecharge/getBalanceConfig/c', //获取余额配置
    getAllRule: config.host + '/market/api/v1/userBalanceRecharge/getAllRule/c', //获取营销规则
    getBalanceDetail: config.host + '/market/api/v1/userBalance/detail/c', //获取营销规则详情

    cardRealNameAuth: config.host + '/market/api/v1/member/realNameAuth/c', //礼品卡实名限购
    cardGetRealNameAuth: config.host + '/market/api/v1/member/getRealName/c', //礼品卡实名限购


    getMyCardTimeList: config.host + '/market/api/v1/storedTimeCard/getMyCardTimeList/c', //获取我的次卡
    getMyCardTimeUseList: config.host + '/market/api/v1/storedTimeCard/getMyCardTimeUseList/c', //该订单可用的次卡
    storedTimeCardList: config.host + '/market/api/v1/storedTimeCard/list/c', //获取次卡列表
    storedTimeCardDetail: config.host + '/market/api/v1/storedTimeCard/detail/c', //获取次卡详情
    storedTimeCardMsg: config.host + '/market/api/v1/storedTimeCard/getMyCardTimeDetail/c', //获取我的次卡详情
    getMyCardTimeLineList: config.host + '/market/api/v1/storedTimeCardManage/getMyCardTimeLineList/c', //获取次卡明细
    purchasingTimeCard: config.host + '/market/api/v1/storedTimeCard/purchasingCard/c', // 次卡购买
    homeGetShowCardTimeList: config.host + '/tktbc/api/v1/showCard/getShowCardTimeList/c', // 首页次卡演出列表
    // homeGetShowCardTimeList: config.host + '/tktbc/api/v1/showCard/getShowCardTimeList/v4/c', // 首页次卡演出列表
    getShowCardTimeListByCardId: config.host + '/tktbc/api/v1/showCard/getShowCardTimeListByCardId/c', // 次卡演出列表
    
}